// src/auth/authService.js
// Login contra la API (PostgreSQL). El backend devuelve un JWT propio.
import { apiPost, clearSession } from '../services/api';
import { fetchMe } from '../services/session';

/** Login con correo y contraseña. Guarda token, rol y correo en localStorage. */
export async function loginAndGetBackendToken(email, password) {
  const data = await apiPost('/auth/login', {
    email: String(email || '').trim(),
    password: String(password || ''),
  }).catch((e) => {
    clearSession();
    throw e;
  });

  if (!data?.token) {
    clearSession();
    throw new Error('Respuesta inválida del servidor (falta token)');
  }

  localStorage.setItem('token', data.token);
  localStorage.setItem('email', data.email || '');
  localStorage.setItem('role', String(data.role || 'viewer').toLowerCase());
  return data;
}

/** Perfil del usuario autenticado (uid, username, email, role, sucursalId). */
export async function getUserProfile() {
  return fetchMe();
}

export function logout() {
  clearSession();
}
